import { useTranslation } from "react-i18next";
import RegistrationHeader from "@/components/auth/registration/Header.tsx";
import { IniDates, RegisterUserInput } from "@/types";
import useFormStep from "@/utils/hooks/useFormStep.ts";
import OutlinedSelect from "@edusogno/inputs/outlined-select";
import AuthPageFooter from "@edusogno/layouts/auth-page-footer.js";
import { cn } from "@edusogno/lib/utils";
import LoadingButton from "@edusogno/primitives/loading-button";
import { useMemo } from "react";
import RegistrationContainer from "../Container";
import RegistrationContent from "../Content";
import { useFormContext } from "react-hook-form";
// import { useFormContext } from "react-hook-form";

interface DateProps {
  className?: string;
  dates: IniDates[];
  onNext: () => void;
}

const RegistrationStartDate = ({ className, dates, onNext }: DateProps) => {
  const { invalid, handleChange } = useFormStep("start_month");
  const { getValues } = useFormContext<RegisterUserInput>();
  const { t, i18n } = useTranslation();
  // const [value, setValue] = React.useState<string>("");
  /* eslint-disable react-hooks/exhaustive-deps */
  const regex = /(\d{1,2}\s[A-Za-z]+\s\d{4})/; // Regular expression to match the date format
  /* eslint-enable react-hooks/exhaustive-deps */

  const options = useMemo(
    () =>
      dates
        .map(
          (date) =>
            date[(i18n.resolvedLanguage as string) || "en"] as unknown as {
              label: string;
              value: string;
            },
        )
        .map((v) => ({
          label: (v.label.match(regex) ?? [v.label])[0],
          value: v.value,
        })),
    [dates, i18n?.resolvedLanguage, regex],
  );

  const defaultPlaceholder = useMemo(() => {
    const date = getValues("start_month");
    return options
      .filter((v) => v.value === date)
      .map((v) => v.label)
      .join("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates, i18n?.resolvedLanguage, regex]);

  return (
    <>
      <RegistrationContainer className={cn("h-full", className)}>
        <RegistrationHeader
          title={t("auth.registration.date_title")}
          subtitle={t("auth.registration.date_subtitle")}
          logo={"date"}
        />
        <RegistrationContent>
          <OutlinedSelect
            label={t("auth.labels.date")}
            options={options as Array<{ label: string; value: string }>}
            // size={"lg"}
            placeholder={
              defaultPlaceholder || t("auth.registration.select_date")
            }
            color={"grey"}
            onValueChange={handleChange}
          />

          {/* {error?.message && (
            <p className="mt-2 text-sm text-red-600">{error.message}</p>
          )} */}
        </RegistrationContent>
      </RegistrationContainer>
      <AuthPageFooter>
        <LoadingButton
          size={"lg"}
          type="button"
          className="hidden w-full text-lg tracking-wide md:block"
          disabled={invalid}
          onClick={() => {
            onNext();
          }}
        >
          {t("btns.next")}
        </LoadingButton>
        <LoadingButton
          size={"md"}
          type="button"
          className="block w-full text-lg tracking-wide md:hidden"
          disabled={invalid}
          onClick={() => {
            onNext();
          }}
        >
          {t("btns.next")}
        </LoadingButton>
      </AuthPageFooter>
    </>
  );
};

export default RegistrationStartDate;
